var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSuggestedSparkle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3198_58693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49937 0.604004L9.15877 1.84042L10.3952 2.49984L9.15877 3.15926L8.49937 4.39567L7.83992 3.15926L6.60352 2.49984L7.83992 1.84042L8.49937 0.604004ZM5.33267 4.6665L7.83267 5.99983L5.33267 7.33318L3.99935 9.83318L2.66601 7.33318L0.166016 5.99983L2.66601 4.6665L3.99935 2.1665L5.33267 4.6665ZM5.70767 5.99983L4.59355 5.40563L3.99935 4.2915L3.40514 5.40563L2.29101 5.99983L3.40514 6.59403L3.99935 7.70818L4.59355 6.59403L5.70767 5.99983ZM9.83267 8.16653L8.99937 6.60403L8.16602 8.16653L6.60352 8.99983L8.16602 9.83318L8.99937 11.3957L9.83267 9.83318L11.3952 8.99983L9.83267 8.16653Z",
    fill: "#1863DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3198_58693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuggestedSparkle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SuggestedSparkle.f109a690.svg";
export { ForwardRef as ReactComponent };